import Carousel from "./Carousel";
export type {
  TCarouselProps,
  ICarouselInstance,
  IComputedDirectionTypes,
  CarouselRenderItem,
} from "./types";
export { ILayoutConfig } from "./layouts/stack";

export default Carousel;
